import React from "react";
import { FcGoogle } from "react-icons/fc";
import "../styles/AuthButton.css";

const AuthButton: React.FC = () => {
  const handleLogin = () => {
    const GOOGLE_AUTH = import.meta.env.VITE_GOOGLE_AUTH!
    window.open(GOOGLE_AUTH, "_self");
  };

  return (
    <button onClick={handleLogin} className="auth-button login">
      <FcGoogle style={{ marginRight: "8px", verticalAlign: "middle" }} />
      Login with Google
    </button>
  );
};

export default AuthButton;